export default "__VITE_ASSET__U2hq033t__"